require('./bootstrap');

require('./components/smartTable');
require('./components/datepickers');
require('./components/tableWithCheckbox-preselect');
require('./components/bulkselect');
require('./components/jquery.dirty');
require('./components/rangeRepeater');

require('inputmask/dist/jquery.inputmask')
require('inputmask/dist/bindings/inputmask.binding.js')
require('tablesorter');
require('daterangepicker')
require('bootstrap-datepicker')

import * as Sentry from "@sentry/browser";
import {Integrations} from "@sentry/tracing";

require('./lib/jquery.multisortable/src/jquery.multisortable');

require('bootstrap-select')

$(function () {
    $('[data-toggle="tooltip"]').tooltip({boundary: 'window', 'placement': 'auto', 'offset': 2})


    $('.action-fillfrom').each(function () {
        var $btn = $(this);
        var $from = $('#' + $btn.data('from'));
        var $to = $('#' + $btn.data('to'));

        $(this).click(function () {
            $to.val($from.val());
        }).hover(function () {
            $from.addClass('fillfrom-active')
        }, function () {
            $from.removeClass('fillfrom-active')
        });
    });

    $('.action-fillfrom-address').each(function () {
        var $btn = $(this);

        ['country','zip','city','street','house','extra'].forEach((suffix)=>{
        var $from = $(`#${$btn.data('from')}_${suffix}`);
        var $to = $(`#${$btn.data('to')}_${suffix}`);

        $(this).click(function () {
            $to.val($from.val());
        }).hover(function () {
            $from.addClass('fillfrom-active')
        }, function () {
            $from.removeClass('fillfrom-active')
        });
        })
    });

    $('.action-copy').click(function () {
        $(this).parents('.input-group').find('input')[0].select();
        document.execCommand('copy');
    })

    // https://stackoverflow.com/questions/26018756/bootstrap-button-drop-down-inside-responsive-table-not-visible-because-of-scroll
    $('.table-responsive').on('show.bs.dropdown', function () {
        $('.table-responsive').css("overflow", "inherit");
    });
    $('.table-responsive').on('hide.bs.dropdown', function () {
        $('.table-responsive').css("overflow", "auto");
    })


    $('form').not('.dontdisable').addClass('nodoublesubmit').submit(function (e) {
        var $this = $(this);
        if ($this.data("submitted") !== 'submitted') {
			var enableNeeded = true;
			$(document).bind('frmEnable',function(){
				if(enableNeeded) {
					$disabled.removeClass('disabled');
					$this.data('submitted', 'timeout');
					enableNeeded = false;
				}
			});
            var $disabled = $this.find('button, .btn, input[type=submit], input[type=button]').not('.disabled').addClass('disabled')
            $this.data("submitted", 'submitted');
            setTimeout(function () {
				$(document).trigger('frmEnable');
            }, 15000);

            return true;
        } else {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    });

    $('.validate-json').keyup(function () {
        var errorMsg = "Please match the format requested.";
        var textarea = this;
        // check if the line matches the pattern
        var hasError = isJsonString(this.value);
        if (typeof textarea.setCustomValidity === 'function') {
            textarea.setCustomValidity(hasError ? errorMsg : '');
        } else {
            $(textarea)
                .toggleClass('error', !!hasError)
                .toggleClass('ok', !hasError)
                .attr({title: hasError ? errorMsg : null});
        }
    });

    function isJsonString(str) {
        try {
            JSON.parse(str);
            return o && typeof o === "object";
        } catch (e) {
            return false;
        }
    }


    var $rs = $('.rich-select');
    $rs.selectpicker && $rs.selectpicker({
        width: "150px",
        styleBase: 'btn btn-sm btn-secondary btn-selectbox',
        noneSelectedText: 'Nincs kiválasztás',
        noneResultsText: 'Nincs találat: {0}',
        selectAllText: 'Mindet',
        deselectAllText: "Semelyiket",
        actionsBox: true,
        liveSearchNormalize: true,
        liveSearch: true,
    })

});


Sentry.init({
    dsn: "https://58786e5761c94829bd205bbbfbcc4cd9@o20785.ingest.sentry.io/1432515",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,
});
